/**
 * <lp-review-strip> — schaltet die schmale Stimmen-Leiste automatisch weiter.
 *
 * Bewusst klein gehalten und ohne Abhängigkeit auf das Component-System des
 * Themes: die Leiste hat genau einen Zustand (welches Zitat ist sichtbar) und
 * keine Interaktion außer dem Anhalten.
 *
 * Angehalten wird in drei Fällen:
 *   - prefers-reduced-motion: gar kein Wechsel, das erste Zitat bleibt stehen
 *   - Zeiger darüber oder Tastaturfokus darin: solange gelesen wird
 *   - Tab im Hintergrund: sonst laufen im Hintergrund Timer weiter und beim
 *     Zurückkommen springt die Leiste sofort mehrere Zitate weiter
 *
 * Bei nur einem Zitat passiert nichts — kein Timer, keine Klassenwechsel.
 */
class LupinysReviewStrip extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.lp-revstrip__item'));
    if (this.items.length < 2) return;

    this.index = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-active')));
    this.interval = Number(this.dataset.interval) || 6000;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.reduceMotion.matches) return;

    // Beim Umschalten der Systemeinstellung mitziehen, statt bis zum Reload
    // weiterzulaufen.
    this.onMotionChange = () => (this.reduceMotion.matches ? this.stop() : this.start());
    this.reduceMotion.addEventListener('change', this.onMotionChange);

    this.onEnter = () => this.stop();
    this.onLeave = () => this.start();
    this.onVisibility = () => (document.hidden ? this.stop() : this.start());

    this.addEventListener('pointerenter', this.onEnter);
    this.addEventListener('pointerleave', this.onLeave);
    this.addEventListener('focusin', this.onEnter);
    this.addEventListener('focusout', this.onLeave);
    document.addEventListener('visibilitychange', this.onVisibility);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('pointerenter', this.onEnter);
    this.removeEventListener('pointerleave', this.onLeave);
    this.removeEventListener('focusin', this.onEnter);
    this.removeEventListener('focusout', this.onLeave);
    document.removeEventListener('visibilitychange', this.onVisibility);
    if (this.reduceMotion && this.onMotionChange) {
      this.reduceMotion.removeEventListener('change', this.onMotionChange);
    }
  }

  start() {
    if (this.timer || document.hidden || this.reduceMotion.matches) return;
    this.timer = window.setInterval(() => this.next(), this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.items[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }
}

if (!customElements.get('lp-review-strip')) {
  customElements.define('lp-review-strip', LupinysReviewStrip);
}
